/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const a=(a=>a)(["operational-layers","basemap-base-layers","basemap-ground-layers","ground"]);export{a as excludeTables};
